import { encryptData } from 'shared/services/cryptoService';
import { apiSlice } from 'store/api/apiSlice';

export const resetPasswordApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Step 1: verify old password
    getOldPassword: builder.query<any, string>({
      query: (oldPass) => ({
        url: `GetOldPassword?oldPass=${oldPass}`,
        method: 'GET',
        service: 'djangoTnEmis',
      }),
    }),

    // In ResetPassword.Service.ts
    requestOtp: builder.mutation<any, { UserId: string; newPassword: string }>({
      query: ({ UserId, newPassword }) => {
        const data = {
          userDetails: {
            otp_purpose_id: 6,
            triggered_by_username: UserId,
            triggered_for_username: UserId,
            sms_strings: newPassword, // ← This must be in userDetails
          },
          otpTemplate: {
            TemplateId: '1707167782158667552',
            MobileNo: '',
            TemplateMsg:
              'OTP to reset password for EMIS Username {#var#} is {#var#}. Do not share with anyone. - TNSED',
            var: { var1: '', var2: '' },
          },
        };

        console.log('Sending OTP request with data:', data); // Debug log
        // console.log('Sending OTP request with data:', data); // Debug log

        const encrypted = encryptData(data);
        return {
          url: 'OtpPasswordReset',
          method: 'POST',
          body: encrypted,
          service: 'djangoTnEmis',
        };
      },
    }),
    // In ResetPassword.Service.ts
    otpUpdateNewPass: builder.mutation<
      any,
      {
        username: string;
        otp: string;
      }
    >({
      query: ({ username, otp }) => {
        const data = {
          records: {
            triggered_by_username: username,
            otp_purpose_id: 6,
            otp: otp.trim(),
          },
        };

        console.log('Submitting OTP for verification:', data); // Debug log
        // console.log('Submitting OTP for verification:', data); // Debug log

        return {
          url: 'OtpUpdateNewPass',
          method: 'POST',
          body: data,
          service: 'djangoTnEmis',
        };
      },
    }),
  }),
});

export const {
  useLazyGetOldPasswordQuery,
  useRequestOtpMutation,
  useOtpUpdateNewPassMutation,
} = resetPasswordApi;
